// extracted by mini-css-extract-plugin
module.exports = {"img":"Banner_img__1DGh0","banner":"Banner_banner__k8ykj"};